import { useMemo, useState } from 'react'
import type { ThemePreference } from '../../core/utils/theme'
import { DropdownMenu, type MenuItem } from './DropdownMenu'
import { useThemePreference } from '../hooks/useThemePreference'
import './ThemeMenu.css'

function labelFor(preference: ThemePreference) {
  if (preference === 'system') return 'System'
  if (preference === 'light') return 'Light'
  return 'Dark'
}

export function ThemeMenu() {
  const [open, setOpen] = useState(false)
  const { themePreference, setThemePreference } = useThemePreference()

  const items: MenuItem[] = useMemo(() => {
    const options: ThemePreference[] = ['system', 'light', 'dark']
    return options.map(option => ({
      icon: option === themePreference ? '✓' : undefined,
      label: labelFor(option),
      onClick: () => setThemePreference(option)
    }))
  }, [setThemePreference, themePreference])

  return (
    <div className="menu-container">
      <button
        type="button"
        className="theme-menu-btn"
        onClick={() => setOpen(v => !v)}
        title={`Theme: ${labelFor(themePreference)}`}
        aria-label="Theme"
      >
        Theme
      </button>
      <DropdownMenu isOpen={open} onClose={() => setOpen(false)} items={items} />
    </div>
  )
}
